import { M8ProductType } from 'services/production/types';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { appendFormDataWithObjectValues, customFetch } from 'utils/http';

type Params = {
  idUser: number;
  priceCalculationComponentType: M8ProductType;
  percentageAmount: number;
};

export const setDiscount = async (params: Params): Promise<void> => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8AdminURL('setDiscount'), {
    method: 'POST',
    body,
  });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
